<section class="about">
    <h1 class="title" appBottomTransitionReveal>Sobre mí</h1>

    <div class="about-content">
        <!-- Texto -->
        <div class="text" appFadeInReveal>
            <p class="top-text">Bienvenida/o</p>
            <p>
                Hola! Soy Ana Pellón, psicóloga sanitaria. <br />
                Acompaño a personas que buscan sentirse mejor, entender lo que les
                ocurre y vivir con más equilibrio y bienestar. Trabajo desde una
                perspectiva integradora, cercana y basada en el respeto por los ritmos
                de cada persona.
            </p>
            <p>
                Mi objetivo es ayudarte a reconectar contigo, ofrecerte un espacio seguro
                donde puedas expresarte libremente y construir, juntos, herramientas que
                te permitan afrontar tus dificultades con más calma y confianza.
            </p>
        </div>

        <!-- Imagen + credenciales -->
        <div class="profile">
            <img src="/ana_pellon_psicologa_santander.webp" alt="Ana Pellón - Psicóloga Sanitaria" class="photo photo--mask" fetchpriority="high" decoding="async" appCenterReveal/>
            <p class="credentials" appFadeInReveal>
                Psicóloga N°Col. CA01238 <br />
                Máster en psicología sanitaria. <br />
                Experta en terapias de tercera generación. <br />
                Equinoterapeuta.
            </p>
        </div>
    </div>
</section>